import { IS_LOCAL } from '../../config/env';
import { nap } from '../utils';
import { WAIT_RETY_MS, MAX_RETRIES } from './config';
import { HOOKS } from './constants';
import { prepVictoryMsgDiscord } from './UI';


export const postVictoryDiscord = (args) => {
  IS_LOCAL && console.log('posting victory', { args });
  // Prep Game Result  
  const { msg, board } = prepVictoryMsgDiscord(args);
  // Send Message
  const webhookUrl = IS_LOCAL ? HOOKS.MATCH_END.TEST : HOOKS.MATCH_END.PROD;
  notify({ webhookUrl, msg, image: board });
};


const attemptsTracker = {};

const notify = async ({ webhookUrl, msg, image, attempt = 1 }) => {
  if (attempt > 1) await nap(WAIT_RETY_MS);
  const urlTail = webhookUrl.split('/').pop();
  try {
    // track request
    attemptsTracker[urlTail] = attempt;
    IS_LOCAL && console.log(`Sending discord notification ${urlTail} - #`, attempt);
    // prep body with optional attachment
    const body = { content: msg };
    if (image) {
      body.embeds = [{ image: { url: image } }];
    }
    // send request
    fetch(
      webhookUrl,
      {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(body),
      },
    )
      .then((res) => {
        if (res.status < 300) {}
        else {
          console.error('something went wrong notifying channel:', { res });
          if (attempt <= MAX_RETRIES) notify({ webhookUrl, msg, image, attempt: ++attemptsTracker[urlTail] });
        }
      })
      .catch(err => {
        console.error('something broke notifying channel', err);
        if (attempt <= MAX_RETRIES) notify({ webhookUrl, msg, image, attempt: ++attemptsTracker[urlTail] });
      });
  } catch (err) {
    console.error('internal error notifying channel', err);
    if (attempt <= MAX_RETRIES) notify({ webhookUrl, msg, image, attempt: ++attemptsTracker[urlTail] });
  }
};
